import styles from "./expensePayeeCard.module.css";
import { Dropdown } from "react-bootstrap";
import { Edit, MoreVertical, Trash2 } from "react-feather";
import { Link } from "react-router-dom";
import dayjs from "dayjs";

const ExpensePayeeCard = ({
  item,
  setDeleteModalOpen,
  setSelectecId,
  setEditModalOpen,
  setEditUserData,
}) => {
  return (
    <Link
      className={`${styles.ProspectCard}`}
      onClick={(e) => {
        if (item?.is_primary) return;
        setEditModalOpen(true);
        setEditUserData(item);
      }}
    >
      <div className={`${styles.ProspectCardUnder}`}>
        <div className={`${styles.ProspectCardHeadSection}`}>
          {!item?.is_primary && (
            <Dropdown
              className={`${styles.ActionLeaseBUSec}`}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <Dropdown.Toggle
                className={`${styles.ActionsLeaseBU} ActionsBU`}
                id="dropdown-basic"
              >
                <MoreVertical />
              </Dropdown.Toggle>

              <Dropdown.Menu className={`${styles.ActionsBUList}`}>
                <Dropdown.Item
                  className={`${styles.EditActionsBUListItem}`}
                  onClick={(e) => {
                    setEditModalOpen(true);
                    setEditUserData(item);
                  }}
                >
                  <Edit /> Edit
                </Dropdown.Item>
                <Dropdown.Item
                  className={`${styles.EditActionsBUListItem} ${styles.Delete}`}
                  onClick={(e) => {
                    setDeleteModalOpen(true);
                    setSelectecId(item.id);
                  }}
                >
                  <Trash2 /> Delete
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}

          <div className={`${styles.ProsIMGSec}`}>
            <img src="/static/img/manage-payee.svg" alt="" />
          </div>
          <div className={`${styles.HeadConSec}`}>
            <p className={`${styles.ProsUserName}`}>
              <span className={`${styles.UserName}`}>{item?.company_name}</span>
            </p>
            <p className={`${styles.ProsUserName} ${styles.Small}`}>{item?.category?.title}</p>
          </div>
        </div>
        <div className={`${styles.ProspectCardFootSec}`}>
          <p className={`${styles.LeaseConDate}`}>
            {dayjs(item?.created_at).fromNow()}
          </p>
          <p className={`${styles.LeaseConDate}`}>
            Total paid amount: ${item?.paid_amount}
          </p>
        </div>
      </div>
    </Link>
  );
};

export default ExpensePayeeCard;
